define('shoptheme/components/blocks/privacy/opt',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem"
], function(
	$,
	Component,
	BEM
) {

	return Component.create({
		supportsLocalStorage:	false,

		init: function() {
			this.supportsLocalStorage = (function() {
				var mod = 'test_ls_' + ~~(Math.random(1,100) * 100000);
				try {
					localStorage.setItem(mod, mod);
					localStorage.removeItem(mod);
					return true;
				} catch(e) {
					return false;
				}
			})();
		},

		$init: function() {
			var self = this;
			var checkboxSelector = '.' + BEM.buildElementClassname('privacy-opt', 'checkbox');

			function paintCheckboxes() {
				$(checkboxSelector).each(function() {
					var checkbox = $(this),
						flag = checkbox.data('flag'),
						value = self.getFlagValue(flag);

					checkbox.prop('checked', !!~~value);
				});
			}

			paintCheckboxes();

			if ("magnificPopup" in $) {
				(function() {
					var _appendContent = $.magnificPopup.proto.appendContent;

					$.magnificPopup.proto.appendContent = function(data) {
						_appendContent.call(this, data);
						paintCheckboxes();
					}
				})();
			}

			$(document.body).on("click", checkboxSelector, function(e) {
				var checkbox = $(e.currentTarget),
					flag = checkbox.data('flag'),
					value = checkbox.is(':checked');

				self.setFlagValue(flag, ~~!!value);
			});
		},

		getFlagValue: function(flag) {
			var value = false;

			if (flag && this.supportsLocalStorage) {
				value = localStorage.getItem(flag);
			}

			return value;
		},

		setFlagValue: function(flag, value) {
			if (flag && this.supportsLocalStorage) {
				localStorage.setItem(flag, value);
			}
		}
	});
});
